var _circle, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUploadImageIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 26,
    stroke: "#19305A",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5613_39577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0685 37.125L35.091 37.1475L35.1146 37.125H37.134C37.4301 37.1247 37.7139 37.0069 37.9232 36.7974C38.1325 36.5879 38.25 36.304 38.25 36.0079V17.9921C38.2479 17.6967 38.1297 17.4139 37.9209 17.2049C37.7121 16.9958 37.4294 16.8774 37.134 16.875H16.866C16.2495 16.875 15.75 17.3756 15.75 17.9921V36.0079C15.7521 36.3033 15.8703 36.5861 16.0791 36.7951C16.2879 37.0042 16.5706 37.1226 16.866 37.125H35.0685ZM18 30.375V19.125H36V34.875L24.75 23.625L18 30.375ZM18 33.5565L24.75 26.8065L32.8185 34.875H18V33.5565Z",
    fill: "#19305A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5088,
    cy: 23.084,
    r: 2.25,
    fill: "#19305A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5613_39577)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 7.875,
    fill: "#19305A",
    stroke: "#19305A",
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.375 40.275H40.275V39.375V36C40.275 35.8757 40.3757 35.775 40.5 35.775C40.6243 35.775 40.725 35.8757 40.725 36V39.375V40.275H41.625H45C45.1243 40.275 45.225 40.3757 45.225 40.5C45.225 40.6243 45.1243 40.725 45 40.725H41.625H40.725V41.625V45C40.725 45.1243 40.6243 45.225 40.5 45.225C40.3757 45.225 40.275 45.1243 40.275 45V41.625V40.725H39.375H36C35.8757 40.725 35.775 40.6243 35.775 40.5C35.775 40.3757 35.8757 40.275 36 40.275H39.375ZM28.35 40.5C28.35 47.2104 33.7896 52.65 40.5 52.65C47.2104 52.65 52.65 47.2104 52.65 40.5C52.65 33.7896 47.2104 28.35 40.5 28.35C33.7896 28.35 28.35 33.7896 28.35 40.5Z",
    fill: "#EFF2F3",
    stroke: "#19305A",
    strokeWidth: 1.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5613_39577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(13.5 13.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5613_39577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(27 27)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUploadImageIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/uploadImageIcon.099005c1.svg";
export { ForwardRef as ReactComponent };